<template>
  <div id="sign-up-card" class="uk-position-center">
    <div class="uk-card">
      <div class="uk-card-body">
        <div @click="close"
             @mouseleave="resolveHover(false)"
             @mouseover="resolveHover(true)"
             class="uk-position-top-right add-pointer
              close-icon">
          <img :src=closeIcon
               v-if="!hover">
          <img :src=hoverIcon
               v-else>
        </div>
        <h2 class="uk-card-title"> {{$t('legacyCards.legacyLogin.title')}}</h2>
        <div class="uk-flex uk-flex-center">
          <img class="modal-icon" :src="legacySingInIcon"/>
        </div>
        <p>{{$t('legacyCards.legacyLogin.paragraphOne')}}</p>
        <p>{{$t('legacyCards.legacyLogin.paragraphTwo')}} <a :href="link" target=”_blank” class="link">{{$t('general.learnMore')}}.</a></p>
        <div class="uk-flex uk-flex-center sign-up-button">
          <button @click="login" class="uk-button cp-primary-button uk-modal-close">
            {{$t('general.signUp')}}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import iconUtil from '../../../utils/icon-util'
  import * as misc from '../../../enums/misc'
  import {LEGACY_EXCHANGE_DOMAIN, SIGN_IN_SIGNUP_GUIDE} from '../../../enums/static-urls'
  import {HOME} from '../../../enums/routes'

  export default {
    name: 'legacy-sign-up-card',
    data() {
      return {
        closeIcon: iconUtil.resolve(misc.CANCEL_BLACK),
        hoverIcon: iconUtil.resolve(misc.CANCEL_HOVER),
        legacySingInIcon: iconUtil.resolve(misc.LEGACY_SIGN_IN),
        link: SIGN_IN_SIGNUP_GUIDE,
        hover: false
      }
    },
    methods: {
      resolveHover(hover) {
        this.hover = hover
      },
      close() {
        window.location = LEGACY_EXCHANGE_DOMAIN
      },
      login() {
        let state = {
          from: HOME,
          download: false
        }
        this.$auth.id.signIn(state)
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '../../../styles/breakpoints';
  @import '../../../styles/colours';

  #sign-up-card{
    z-index: 3;
  }

  .uk-card {
    background-color: $app-background;
    width: 908px;
    min-height: 549px;
    text-align: center;
    padding-left: 15px;
    padding-right: 15px;

    p {
      font-size: 18px;
      line-height: 1.11;
      color: $content-text;
    }

    .modal-icon {
      width: 190px;
      height: 190px;
      padding-bottom: 25px;
    }

    .link {
      color: $content-link-blue;
      font-weight: bold;
      font-size: 18px;
    }

    .cp-primary-button {
      width: 254px;
      height: 44px;
      text-transform: none;
      font-size: 20px;
      font-weight: bold;
    }
  }

  .sign-up-button {
    padding-top: 25px;
  }

  .uk-card-title {
    font-size: 24px;
    font-weight: bold;
    line-height: 1.29;
    color: $content-text;
    margin-top: 0px;
    padding-bottom: 25px;
  }
  @media screen and (max-width: $breakpoint-medium) {
    .uk-card-title {
      font-size: 18px;
    }

    .uk-card {
      width: 550px;
      min-height: 549px;

      p {
        font-size: 16px;
      }

      .link {
        font-size: 16px;
      }
    }
  }

  @media screen and (max-width: $breakpoint-small) {
    .uk-card {
      width: 315px;
      min-height: 549px;
      padding-left: 5px;
      padding-right: 5px;
    }
  }

</style>


